


















import { Component, Vue } from 'vue-property-decorator'
import { RouteName } from '@/router/index'

@Component({})
export default class Header extends Vue {
  private get routeName() {
    return RouteName
  }
}
